import React from 'react';

const About = () => {
    return (
        <div className="aboutpage" >
            <h2 className="about-line" >About</h2>
            <p>Welcome to our interactive news application! Powered by React, this platform brings you the latest news articles from various categories, ensuring you stay informed with just a click. Our intuitive design allows you to filter articles by categories such as technology, business, sports, and more, providing a tailored news experience. We've implemented efficient pagination so you can seamlessly navigate through multiple pages of articles. Whether you're a news enthusiast, researcher, or simply curious about current affairs, our application aims to deliver relevant news efficiently and responsively. Enjoy exploring and discovering the stories that matter to you.</p>
        </div>
    );
};

export default About;
